/** @format */

import React, { useState, useEffect } from "react";
import Checkbox from "./Checkbox";
import Radio from "./Radio";
import { Button, Input } from "antd";
import _uniq from "lodash/uniq";

const ITEMS_TO_SHOW = 5;
const FIXED_MOQ_FILTERS = [
  "1 unit",
  "4 & less",
  "12 & less",
  "24 & less",
  "50 & less",
  "100 & less",
  "200 & less",
  "500 & above",
];
const RADION_TYPE = ["f_categories", "f_isfreeshipping"];
const CheckboxGroup = ({ options, ...props }) => {
  let { filterType } = props;
  const [itemsToShow, setItemsToShow] = useState(ITEMS_TO_SHOW);
  const [showMore, setMore] = useState(false);
  const [filteredList, setFilteredList] = useState([]);
  const [searchVal, setSearchVal] = useState("");
  const [viewAll, setViewAll] = useState(false);
  const [moqFilter, setMoqFilters] = useState([]);
  console.log('====================================');
  console.log("filterType", filterType);
  console.log('====================================');
  useEffect(() => {
    if (props["filterType"] === "f_moqBucket" || props["filterType"] === "moqbucket") {
      let moqFacets = [];
      for (let list of options) {
        let { value: name = "" } = list;
        if (name === "Bucket-R") {
          moqFacets.push("1 unit");
          moqFacets.push("4 & less");
          moqFacets.push("12 & less");
          moqFacets.push("24 & less");
          moqFacets.push("50 & less");
          moqFacets.push("100 & less");
          moqFacets.push("200 & less");
        } else if (name === "Bucket-Q") {
          moqFacets.push("4 & less");
          moqFacets.push("12 & less");
          moqFacets.push("24 & less");
          moqFacets.push("50 & less");
          moqFacets.push("100 & less");
          moqFacets.push("200 & less");
        } else if (
          name === "Bucket-D" ||
          name === "Bucket-F" ||
          name === "Bucket-H" ||
          name === "Bucket-P" ||
          name === "Bucket-S"
        ) {
          moqFacets.push("12 & less");
          moqFacets.push("24 & less");
          moqFacets.push("50 & less");
          moqFacets.push("100 & less");
          moqFacets.push("200 & less");
        } else if (
          name === "Bucket-B" ||
          name === "Bucket-E" ||
          name === "Bucket-G" ||
          name === "Bucket-O"
        ) {
          moqFacets.push("24 & less");
          moqFacets.push("50 & less");
          moqFacets.push("100 & less");
          moqFacets.push("200 & less");
        } else if (name === "Bucket-C" || name === "Bucket-N") {
          moqFacets.push("50 & less");
          moqFacets.push("100 & less");
          moqFacets.push("200 & less");
        } else if (name === "Bucket-M") {
          moqFacets.push("100 & less");
          moqFacets.push("200 & less");
        } else if (name === "Bucket-L") {
          moqFacets.push("200 & less");
        } else if (
          name === "Bucket-K" ||
          name === "Bucket-J" ||
          name === "Bucket-I"
        ) {
          moqFacets.push("500 & above");
        } else if (name === "Bucket-A") {
          moqFacets.push("50 & less");
          moqFacets.push("100 & less");
          moqFacets.push("200 & less");
          moqFacets.push("500 & above");
        } else if (name === "Bucket-T") {
          moqFacets.push("50 & less");
          moqFacets.push("100 & less");
        }
      }
      moqFacets = _uniq(moqFacets);
      let filters = FIXED_MOQ_FILTERS.filter((ele) =>
        moqFacets.includes(ele)
      ).map((item) => ({ value: item, id: item }));
      setFilteredList(filters);
    } else {
      let facets = [];
      for (let list of options) {
        list.count > 0 && facets.push(list);
      }
      setFilteredList(facets);
    }
  }, [options]);

  const checkFocus = (e) => {
    e.target.classList.add('new');
    e.target.parentNode.parentNode.querySelector('.ant-btn').classList.add('new')
    // console.log('eee', e.target.parentNode.parentNode.querySelector('.ant-btn').classList.add('new'));
    // console.log(e.target.nextNode)
  }

  const checkBlur = (e) => {
    e.target.classList.remove('new');
    e.target.parentNode.parentNode.querySelector('.ant-btn').classList.remove('new')
  }

  const onSearchText = (e) => {
    // e.focus();
    // console.log('e', e)
    setSearchVal(e.target.value);
    let { value = "" } = e.target;
    let filterTable = options.filter((o) =>
      Object.keys(o).some((k) =>
        String(o[k]).toLowerCase().includes(value.toLowerCase())
      )
    );
    if (filterTable.length === 0) {
      setViewAll(true);
    } else {
      setViewAll(false);
      setItemsToShow(ITEMS_TO_SHOW);
    }
    setFilteredList(filterTable);
  };

  // set filter fields length to loop over based on props.device type
  let filteredListLength;
  if (props.device === "desktop" && !showMore) {
    filteredListLength = itemsToShow;
  } else {
    filteredListLength = filteredList.length;
  }

  let excludeSearch = ['range', 'f_moqBucket', 'f_material', 'f_values', 'moqbucket', 'values', 'material'];

  return (
    <>
      <div className="ant-checkbox-group" style={{ display: "block" }}>
        {(props?.expandMaterial &&
          (filterType === "f_material" || filterType === "material")) ||
          (props?.expandValue &&
            (filterType === "f_values" || filterType === "values")) || (
            <>
              {RADION_TYPE.includes(filterType) ? (
                <></>
              ) : (
                <div id="select-clear-sec">
                  {/* <div className=" pull-right select-clear-sec "> */}
                  <div
                    className={`pull-right  select-clear-sec ${
                      filterType === "f_key_methods"
                        ? "top-margin-two-lines"
                        : "top-margin-single-lines"
                    }`}
                  >
                    {filterType !== "f_moqBucket" &&
                      filterType !== "moqbucket" && (
                        <>
                          <div
                            className=" qa-pad-0  qa-cursor text-color"
                            type="link"
                            onClick={() => {
                              props.selectFacetFilter(filterType, filteredList);
                            }}
                          >
                            Select all
                          </div>
                          <span className="mob-line">&nbsp;|&nbsp;</span>
                        </>
                      )}
                    {
                      <div
                        className={
                          filterType !== "f_moqBucket" &&
                          filterType !== "moqbucket"
                            ? " qa-pad-0  qa-cursor  text-color"
                            : " qa-pad-0  qa-cursor qa-mar-top-05 text-color"
                        }
                        type="link"
                        onClick={() => {
                          props.clearFacetFilter(filterType);
                        }}
                      >
                        Clear all
                      </div>
                    }
                  </div>
                </div>
              )}
              {options.length > ITEMS_TO_SHOW &&
                !excludeSearch.includes(filterType) && (
                  <div className="qa-mar-btm-1 filter-search-box">
                    <Input.Search
                      placeholder="Search"
                      onChange={onSearchText}
                      value={searchVal}
                      className="slp-search"
                      onFocus={checkFocus}
                      onBlur={checkBlur}
                    />
                  </div>
                )}
              {/* {props.currency && filterType === "range" && props.device === "mobile" && (
        <div className="price-filters-currency">
          <span>Price</span>
          <span>{props.currency}</span>
        </div>
      )} */}
              <div>
                {filteredList.slice(0, filteredListLength).map((label, i) => {
                  let checked = false;
                  if (props[filterType] && props[filterType].length) {
                    if (props.selected === "array") {
                      const selectedValue =
                        props[filterType] &&
                        props[filterType].length &&
                        typeof props[filterType].split !== "undefined"
                          ? props[filterType].split(",")
                          : [];
                      if (selectedValue.indexOf(label.value) !== -1) {
                        checked = true;
                      } else if (selectedValue.indexOf(label.id) !== -1) {
                        checked = true;
                      } else if (
                        ((label.value && label.value.includes(",")) ||
                          (label.id && label.id.includes(","))) &&
                        (props[filterType].includes(label.value) ||
                          props[filterType].includes(label.id))
                      ) {
                        checked = true;
                      }
                    } else if (
                      props[filterType].includes(label.value) ||
                      props[filterType].includes(label.id)
                    ) {
                      checked = true;
                    }
                  }

                  let name = label?.value ? label?.value : label?.name;
                  if (name?.includes("_")) {
                    name = name?.replace(/_/gi, " ");
                  }
                  name = name?.trim();
                  name = name?.charAt(0)?.toUpperCase() + name?.slice(1);
                  if (!name) {
                    return null;
                  }

                  if (
                    props["filterType"] === "f_moqBucket" ||
                    props["filterType"] === "moqbucket"
                  ) {
                    return (
                      <Radio
                        key={`radio-${i}`}
                        label={name}
                        filterId={label.value || label.id}
                        filterType={props.filterType}
                        disabled={props.disabled}
                        handleChange={props.handleChange}
                        value={checked}
                      />
                    );
                  } else {
                    return (
                      <Checkbox
                        key={`checkbox-${i}`}
                        label={name}
                        filterId={label.value || label.id}
                        filterType={props.filterType}
                        disabled={props.disabled}
                        handleChange={props.handleChange}
                        value={checked}
                      />
                    );
                  }
                })}
              </div>

              {props.device === "desktop" &&
                filteredList.length > itemsToShow &&
                !showMore &&
                !viewAll && (
                  <div
                    className="qa-sm-color qa-underline qa-cursor qa-mar-btm-1"
                    onClick={() => {
                      setMore(true);
                      setItemsToShow(options.length);
                    }}
                  >
                    View more
                  </div>
                )}
              {props.device === "desktop" && showMore && !viewAll && (
                <div
                  className="qa-sm-color qa-underline qa-cursor qa-mar-btm-1"
                  onClick={() => {
                    setMore(false);
                    setItemsToShow(ITEMS_TO_SHOW);
                  }}
                >
                  View less
                </div>
              )}
              {viewAll && (
                <div
                  className="qa-sm-color qa-underline qa-cursor qa-mar-btm-1"
                  onClick={() => {
                    setFilteredList(options);
                    setItemsToShow(options.length);
                    setViewAll(false);
                  }}
                >
                  View all
                </div>
              )}
            </>
          )}
      </div>
    </>
  );
};
export default CheckboxGroup;
